export default __webpack_public_path__ + "static/media/easter-hero-3.c2348231.svg";